import { Link } from "react-router-dom";
import { DashboardDefaultContainer } from "../dashboard-default-container";
import FrontDeskHeader from "./front-desk-header";
import { BookUser, ChevronRight, Send, Users } from "lucide-react";
import { IdCardIcon, ReaderIcon } from "@radix-ui/react-icons";
import GenericHeader from "src/components/ui/GenericHeader";
import { useEffect, useState } from "react";

const FrontDeskView = () => {
  const path = window.location.pathname;

  const [currentPath, setCurrentPath] = useState("");

  useEffect(() => {
    const changePath = () => {
      if (path.startsWith("/admin")) {
        setCurrentPath("/admin");
      } else if (path.startsWith("/front-desk")) {
        setCurrentPath("/front-desk");
      }
    };
    changePath();
  }, [path]);

  const frontDeskRoutes = [
    {
      path: `${currentPath}/view-candidates`,
      title: "View Candidates",
      icon: <Users />,
    },
    {
      path: `${currentPath}/view-ebook-users`,
      title: "View E-Book Users",
      icon: <BookUser />,
    },
    {
      path: `${currentPath}/view-admit-cards`,
      title: "View Admit Cards",
      icon: <IdCardIcon className="w-[25px] h-[25px]" />,
    },
    {
      path: `${currentPath}/view-results`,
      title: "View Results",
      icon: <ReaderIcon className="w-[25px] h-[25px]" />,
    },
    {
      path: '/send-email',
      title: "Send Notification",
      icon: <Send />,
    },
  ];

  return (
    <DashboardDefaultContainer>
      <GenericHeader />
      <FrontDeskHeader />
      <div className="flex gap-3 justify-evenly py-4">
        {frontDeskRoutes.map((route) => (
          <Link to={route.path}>
            <div className="w-[260px] h-[111px] border border-black rounded-lg hover:bg-zinc-200 hover:shadow-lg hover:shadow-slate-400 flex justify-center items-center gap-3 flex-col">
              <h1 className="text-xl font-semibold flex gap-3">
                {route.title} <ChevronRight className="size-8" />
              </h1>
              {route.icon}
            </div>
          </Link>
        ))}
      </div>
    </DashboardDefaultContainer>
  );
};

export default FrontDeskView;
